<template>
<!-- 预览图片的操作按钮 保存、撤回 -->
  <div class="preview-options" @click="closePreviewOptions" v-if="showPreviewOptionsFlag" style="box-shadow: 0 0 8px 0 rgb(188 189 191), 0 2px 4px 0 rgb(204 205 208);width: 70px;text-align: center;margin-left: 10px;position: fixed;z-index: 9999;font-size: 12px;border-radius: 4px;background: #fff;" :style="{'left':bigImgClickPostion.pageX+'px','top':bigImgClickPostion.pageY+'px'}">
        <p style="margin: 0px;height: 24px;line-height: 24px;cursor: pointer;" class="bg-g-100-hover"  @click="downloadFile">保存</p>
        <p style="margin: 0px;height: 24px;line-height: 24px;cursor: pointer;" class="bg-g-100-hover" @click="deleteMsg" v-if="(previewItem.flow==='out' || teamOwner == myAccount) && lastContextmenuTime - previewItem.time < 2*60*1000 && lastContextmenuTime - previewItem.time >0 && previewItem.from != previewItem.to">撤回</p>
    </div>
</template>
<script>
export default {
  props: {
    bigImgClickPostion:{
        type:Object,
        default:function(){
          return {
            pageX: 1000,
            pageY: 100
          }
        }
    },
    showPreviewOptionsFlag:{
        type: Boolean,
        default: true
    },
    previewItem:{
      type: Object,
      default: function(){
        return {}
      }
    },
    myAccount:{
      type: String,
      default: ""
    },
    teamOwner:{
      type: String,
      default: ""
    },
    im: {
      type: Object,
      default: function () {
        return {};
      }
    },
  },
  data: function () {
    return {
      lastContextmenuTime: 0
    };
  },
  methods: {
    downloadFile:function(){
      let $this = this;
      console.log("$this.previewItem",$this.previewItem);
      axiosHttpIm.get($this.previewItem.file.url, {
        responseType: 'blob'
      }).then(function (res) {
        let blob = new Blob([res], {
          type: res.type
        }); //创建Blob对象;
        let link = document.createElement('a'); //创建a标签;
        let filename = $this.previewItem.file.name;
        link.href = window.URL.createObjectURL(blob); //创建对象超链接;
        link.download = filename; //设置下载excel文件名称;
        // 配置下载的文件名
        if (navigator.userAgent.indexOf("Firefox") > -1) {
          document.body.appendChild(link); //把a标签添加到body后面;
          link.click(); //触发a标签点击事件;
          link.remove();
        } else {
          link.click();
        }
      }).catch(function(){});
    },
    deleteMsg:function(){
      let $this = this;
      if(!$this.isTimeOut()){
        return;
      }
      $this.$emit("deletePreviewImg",$this.previewItem);
    },
    isTimeOut:function(){
      let nowTime = new Date().getTime()
      if(nowTime - this.previewItem.time < 2*60*1000 && nowTime - this.previewItem.time >0){
        return true;
      }
      this.$message.warning("发送时间超过2分钟的消息，不能被撤回");
      return false;
    },
    closePreviewOptions:function(){
      this.$emit("closePreviewOptions")
    },
    closePreviewOptions1(e){
      if(this.showPreviewOptionsFlag && !(e.target.parentNode && e.target.parentNode.classList.length >0 && e.target.parentNode.classList[0] == "preview-options")){
        this.closePreviewOptions();
      }
    }
  },
  mounted: function () {
    window.addEventListener("click",this.closePreviewOptions1,false)
  },
  watch:{
    showPreviewOptionsFlag(val){
      if(val){
        this.lastContextmenuTime = new Date().getTime();
      }
    }
  },
  beforeDestroy: function () {
    window.removeEventListener("click",this.closePreviewOptions1,false)
  }
};
</script>
